<div class="manage-forecasts-content">
  <div class="page-header">
    <wfm-page-title title="{{'imported.forecasts.page.title' | translate}}"></wfm-page-title>
    <breeze-button *ngIf="hasEspModifyPermission" buttonText="{{'manage.forecasts.import.button.label' | translate}}" id="btn-import-forecasts" [isPrimary]="true" (clicked)="showImportForecastsDlg()"></breeze-button>
  </div>
  <div class="search-box">
    <input-text #searchTextBox inputId="search-text-box" [isSearchField]="true" [isDisabled] = "false"
                [required]="false"
                placeHolderText="{{'imported.forecasts.search.box' | translate}}"
                ariaLabel="{{'imported.forecasts.search.label' | translate}}"
                [announcement]="searchAnnouncement"
                (onTextChangeWithTimeout)="filterRows($event)">
    </input-text>
    <div class="search-actions">
      <ng-template #multiForecastsDelete>
        <div role="dialog"
             aria-labelledby="forecast-delete-title"
             tabindex="-1"
             (keydown.tab)="onForecastDeleteDialogTab($event)"
             (keydown.shift.tab)="onForecastDeleteDialogTab($event)">
          <div class="message-delete">
            <p id="forecast-delete-title">{{'imported.forecasts.delete.multiple' | translate }} </p>
          </div>
          <div class="button-response">
            <breeze-button [isSecondary]="true" [showTooltip] = "false" buttonText="{{'btn.cancel.label' | translate }}" (clicked)="forecastDeletePopover.close()"></breeze-button>
            <breeze-button [isPrimary]="true" [showTooltip] = "false" buttonText="{{'btn.confirm.label' | translate }}" (clicked)="deleteSelectedForecasts()"></breeze-button>
          </div>
        </div>
      </ng-template>
      <div *ngIf="hasEspModifyPermission">
        <breeze-button #forecastDeletePopover="ngbPopover" buttonText="{{'imported.forecasts.label.delete' | translate}}"
                      [isSecondary]="true"
                      [isDisabled]="!hasSelectedImportedForecasts"
                      id="btn-delete"
                      placement="left"
                       tooltipPosition="left"
                      (shown)="focusForecastDeleteDialog()"
                      (hidden)="returnFocusToForecastDeleteBtn()"
                      [ngbPopover]="multiForecastsDelete">
        </breeze-button>
      </div>
    </div>
  </div>
  <div class="imported-forecasts-list table-list">
    <!-- a11y (ESP-18522): row-level open action announced once on grid entry
         via aria-describedby; each cell still announces only its own content. -->
    <p id="forecastGridActivationHelp" class="screenreader-only">{{ 'imported.forecasts.grid.activation.help' | translate }}</p>
    <!-- a11y (ESP-21718 family) / ESP-21806: columns are not draggable at all
         ([suppressMovableColumns]), so there is no column-reorder DOM/Tab-order
         desync to fix and no need for the grid-wide `ensureDomOrder` option
         (whose forced body-row DOM re-splicing on scroll recycle caused stale
         hover / duplicate tooltips during fast scrolling on the plan list grid,
         ESP-21806). -->
    <ag-grid-angular full-width-table
                     [noRowsOverlayComponent]="noRowsOverlayComponent"
                     [noRowsOverlayComponentParams]="noRowsOverlayComponentParams"
                     [tableRef]="importedForecastsList"
                     class="ag-theme-balham no-column-borders"
                     (cellClicked)="performCellClick($event)"
                     (cellKeyDown)="onCellKeyDown($event)"
                     (cellFocused)="onCellFocused($event)"
                     (focusout)="onGridFocusOut($event)"
                     [rowSelection]="rowSelection"
                     [selectionColumnDef]="selectionColumnDef"
                     [suppressAutoSize]="true"
                     [columnDefs]="columnDefs"
                     [context]="context"
                     [headerHeight]="40"
                     [suppressMovableColumns]="true"
                     [icons]="icons"
                     [localeText]="gridAriaLocaleText"
                     [defaultColDef]="defaultColDef"
                     #importedForecastsList
                     [components]="frameworkComponents"
                     (gridReady)="onGridReady($event)"
                     (firstDataRendered)="applyCheckboxAriaLabels()"
                     (rowDataUpdated)="applyCheckboxAriaLabels()"
                     (selectionChanged)="applyCheckboxAriaLabels()"
                     (modelUpdated)="applyCheckboxAriaLabels()"
                     [rowClassRules]="rowClassRules"
                     [rowHeight]="36"
                     [animateRows] ="true"
                     [rowModelType]="rowModelType"
                     [cacheBlockSize]="cacheBlockSize"
                     [infiniteInitialRowCount]="infiniteInitialRowCount"
                     [rowBuffer]="rowBuffer"
                     [loadingOverlayComponent]="loadingOverlayComponent"
                     [loadingOverlayComponentParams]="loadingOverlayParams"
                     [enableBrowserTooltips]="true">
    </ag-grid-angular>
  </div>
</div>
<p-toast position="bottom-right">
</p-toast>
